module.exports = {
  name: 'Interior Hero',
  context: {
    heading: {
      text: 'Our Work',
      tag: '',
      class: 'heading-1'
    },
    breadcrumbs: '@breadcrumb'
  },
  variants: [
    {
      name: 'Hero with Image',
      context: {
        breadcrumbs: '@breadcrumb',
        heading: {
          text: 'Catalysts',
          tag: 'h1',
          class: 'heading-1'
        },
        bannerImage: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/veterans.jpg?mtime=20210628092505&focal=none',
          alt: 'Catalysts'
        }
      }
    },
    {
      name: 'Image and Icon',
      context: {
        breadcrumbs: '@breadcrumb',
        heading: 'Catalysts',
        icon: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/icon-catalysts.svg?mtime=20210624092153&focal=none',
          alt: 'catalysts'
        },
        bannerImage: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/veterans.jpg?mtime=20210628092505&focal=none',
          alt: 'Catalysts'
        }
      }
    },
    {
      name: 'Article',
      context: {
        heading: {
          text: 'Adjoin to partner with STRIVE',
          tag: 'h1',
          class: 'heading-1'
        },
        date: 'February 24, 2021',
        entryType: {
          title: 'Press Release',
          url: '/latest/press-releases'
        },
        breadcrumbs: '@breadcrumb'
      }
    },
    {
      name: 'Search Results',
      context: {
        type: 'text-only',
        searchTerm: 'search term',
        results: '16'
      }
    }
  ]
}
